import React from 'react';
import { useSelector } from 'react-redux';
import ICTDistrictType from '../../../../../../enums/ICTDistrictType';
import classes from './DistrictCell.module.css';

const DistrictCell = ({ value }) => {

  const { texts } = useSelector((state) => state.translate);
  const districtId = typeof value === 'string' ? parseInt(value, 10) : value;
  const districtName = texts[ICTDistrictType[districtId]] || value || '';

  return (
    <div className={classes.districtCell}>
      {districtName}
    </div>
  );
};

export default DistrictCell;
